import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import OverlayContext from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard/Overlay/OverlayContext';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import ThumbInfo from '@wix/da-shared-react/pkg/ThumbInfo';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import {
  getDeviationType,
  getDeviationResourceType,
  getDeviationTitle,
} from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { normalizePremiumFolderData } from '@wix/da-shared-react/pkg/utils/normalizePremiumFolderData';
import DeviationPaywall from '../../_partials/paywalls/DeviationPaywall';

import s from './FeaturedPostThumb.scss';

export interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  hideThumbInfo?: boolean;
}

export const FeaturedPostThumb: React.FC<Props> = ({
  deviation: { author, deviationId },
  deviation,
  width,
  height,
  hideThumbInfo = false,
}) => {
  const { pointPrice, folderId } = normalizePremiumFolderData(
    deviation.premiumFolderData
  );
  const deviationTitle = getDeviationTitle(deviation);

  return (
    <div className={s['root']}>
      <ErrorBoundary debugComponent="FeaturedPostThumb">
        <DeviationPaywall
          isLiterature={
            getDeviationType(deviation) === DeviationTypes.LITERATURE
          }
          premiumFolderData={deviation.premiumFolderData}
          contentOwner={author!}
          biData={{
            evid: BiEventType.GALLERY_PURCHASE,
            points: pointPrice,
            typeid: getDeviationResourceType(deviation),
            itemid: deviationId,
            galleryid: folderId,
            authorid: author && author.useridUuid, // This is NOT the gallery owner
          }}
        >
          <OverlayContext.Consumer>
            {value => (
              <OverlayContext.Provider
                value={{
                  ...value,
                  showAuthor: false,
                  showTitle: false,
                }}
              >
                <StandardThumb
                  deviation={deviation}
                  width={width}
                  height={height}
                />
              </OverlayContext.Provider>
            )}
          </OverlayContext.Consumer>
        </DeviationPaywall>
        {!hideThumbInfo && (
          <ThumbInfo
            urlDeviation={deviation}
            user={author!}
            title={deviationTitle}
          />
        )}
      </ErrorBoundary>
    </div>
  );
};
FeaturedPostThumb.displayName = 'FeaturedPostThumb';

export default FeaturedPostThumb;
